<template lang="pug">
    .animations(ref='animation')
        .handcuffs(ref='handcuffs')
            img(src='../../assets/img/animations/handcuffs.svg')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline.fromTo(this.$refs.handcuffs, {rotate: 0}, {rotate: 720, transformOrigin: '50% 45%'}, 0);
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';
.animations {
    width: 100%;
    padding-left: calc(var(--grid-column) * 2);
    @media (--viewport-tablet) {
        padding: var(--grid-column-mobile);
    }
}
</style>
